import { useState as S, useEffect as _, useCallback as n, useMemo as f } from "react";
import { useAuth as v } from "react-oidc-context";
import { useConfig as A } from "@dcentralexpedientedigital/fe-ui/hooks/use-config";
import { useIntlStore as h } from "../stores/intl-store.js";
import { useGTM as w } from "./use-gtm.js";
const M = () => {
  var d, g;
  const { trackEvent: r } = w(), e = v(), u = h((i) => i.locale), { name: o } = A(), [l, p] = S(!1);
  _(() => {
    var i, m;
    (e == null ? void 0 : e.isAuthenticated) !== void 0 && ((m = (i = e == null ? void 0 : e.user) == null ? void 0 : i.profile) != null && m.sub) && p(!0);
  }, [e == null ? void 0 : e.isAuthenticated, (g = (d = e == null ? void 0 : e.user) == null ? void 0 : d.profile) == null ? void 0 : g.sub]);
  const s = n(
    (i) => ({
      ...i,
      extraQueryParams: {
        ui_locales: u,
        ...(i == null ? void 0 : i.extraQueryParams) ?? {}
      }
    }),
    [u]
  ), t = f(
    () => ({
      ...e,
      signinRedirect: (i) => e.signinRedirect(s(i)),
      signinPopup: (i) => e.signinPopup(s(i)),
      signinSilent: (i) => e.signinSilent(s(i)),
      signoutSilent: (i) => e.signoutSilent(s(i))
    }),
    [e, s]
  ), a = n(() => {
    t.signinRedirect({ redirectMethod: "replace", redirect_uri: window.location.origin });
  }, [t]), c = n(async () => {
    await t.signoutSilent({
      post_logout_redirect_uri: window.location.origin + "/auth/logout.html"
    }), r({
      event: "logout",
      payload: {
        brand: o
      }
    }), r({
      event: "user_context_cleared",
      payload: {
        authStatus: "logged_out",
        userId: void 0,
        brand: o
      }
    });
  }, [t, r, o]);
  return f(
    () => ({
      login: a,
      logout: c,
      auth: t,
      isAuthResolved: l
    }),
    [a, c, t, l]
  );
};
export {
  M as useAuth
};
